export const moduleConfig = {
    basePath: '/provider-mappings',
    titles: {
        singular: 'Provider Mapping',
        plural: 'Provider Mappings'
    },
};
